import React, { Component, Fragment } from 'react';
import { Button, Modal, DatePicker, Tag, message, Icon, Tooltip } from 'antd';
import { Customer }  from '../../../../services/api'; 

export default class SaveMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            modalVisible: false,
            customer: this.props.customer,
            menu: this.props.menu,
            customerMenu: this.props.customerMenu,
            weeks: this.props.weeks ? this.props.weeks : [],
        }

        this.customerApi = new Customer(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.customer !== this.state.customer) {
            this.setState({ customer: nextProps.customer });
        }
        if (nextProps.menu !== this.state.menu) {
            this.setState({ menu: nextProps.menu });
        }
        if (nextProps.customerMenu !== this.state.customerMenu) {
            this.setState({ customerMenu: nextProps.customerMenu });
        }
        if (nextProps.weeks && nextProps.weeks.length !== 0) {
        
            this.setState({ weeks: nextProps.weeks });
        }
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    showAddModal = () => {
        if (this.props.disabled) {
            return;
        }
        this.setState({ modalVisible: true });
    }

    handleOk = () => {
        const { editing } = this.props;

        if (editing) {
            this.patchMenu();
            return;
        }
        this.createMenu();
    }

    handleCancel = () => {
        this.setState({ modalVisible: false, weeks: [] });
    }

    createMenu = () => {
        const { customer, menu, weeks } = this.state;
        const data = {
            origin_id: menu.id,
            weeks: weeks
        };

        this.setState({ loading: true });
        this.customerApi.raw().post(customer._links['add-menu'].href, data)
            .then(res => {
                this.props.onSave(res.data.data);
                this.setState({ loading: false, modalVisible: false, weeks: [] });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.createMenu });
            });
    }

    patchMenu = () => {
        const { menu, customerMenu, weeks } = this.state;
        const data = {
            origin_id: menu.id,
            weeks: weeks
        };
        
        this.setState({ loading: true });
        this.customerApi.raw().patch(customerMenu._links.patch.href, data)
            .then(res => {
                res.data.data.origin = menu;
                this.props.onSave(res.data.data);
                this.setState({ loading: false, modalVisible: false });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.patchMenu });
            });
    }

    onWeekChange = (date) => {
        if (!date) {
            return;
        }

        const { weeks } = this.state;
        const week = date.isoWeek();

        const allocatedWeeks = weeks.concat(this.props.allocatedWeeks);
        const index = allocatedWeeks.findIndex(w => w === week);
        if (index !== -1) {
            message.error(`Det finns redan en meny sparad för vecka: ${week}`);
            return;
        }

        weeks.push(week);
        this.setState({ weeks });
    }

    removeWeek = (week) => {
        const { weeks } = this.state;
        const index = weeks.findIndex(w => w === week);
        if (index !== -1) {
            weeks.splice(index, 1);
            this.setState({ weeks });
        }
    }

    render() {
        const { menu, iconOnly, exists, editing } = this.props;
        const { loading, modalVisible, weeks } = this.state;
        
        return (
            <Fragment>
                {iconOnly ?
                    <Tooltip title={exists ? 'Menyn finns redan sparad' : 'Spara till mina menyer'}>
                        {exists 
                            ? <Icon type="heart" theme="twoTone" twoToneColor="#eb2f96"/>
                            : <Icon type="heart" onClick={this.showAddModal}/>
                        }
                        
                    </Tooltip>
                    : (
                        <div>
                            {editing && (
                                <Button disabled={exists} className={this.props.className} style={this.props.style} type="primary" icon="edit" onClick={this.showAddModal}>
                                    Ändra veckor
                                </Button>    
                            )}
                            {!editing && (
                                <Button disabled={exists} style={this.props.style} type="primary" icon="heart" onClick={this.showAddModal}>
                                    {exists ? 'Menyn finns redan sparad' : 'Spara till mina menyer'}
                                </Button>
                            )}
                        </div>
                    )
                }
                
                <Modal
                    title={editing ? `Ändra veckor för: ${menu.title}` : `Spara: ${menu.title}`}
                    visible={modalVisible}
                    okText="Spara"
                    cancelText="Avbryt"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okButtonProps={{ loading: loading }}
                >                    
                    <div>
                        <div style={{ marginBottom: '20px' }}>
                            { weeks.map(w => (
                                <Tag key={w} closable color="volcano" onClose={(e) => this.removeWeek(w)}>v{w}</Tag>
                            ))}
                        </div>
                        <DatePicker.WeekPicker 
                            value={null}
                            onChange={this.onWeekChange}
                            style={{ width: '100%' }}
                            placeholder="Välj veckor som menyn ska gälla för" 
                        />
                    </div>  
                </Modal>
            </Fragment>
        )
    };
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/SaveMenu.js